import { useState, useEffect, useRef, useCallback } from "react";
//import "datatables.net-dt/js/dataTables.dataTables"
//import "datatables.net-dt/css/jquery.dataTables.min.css"
import { Link } from "react-router-dom";
import { tokenDecode } from "../../utils/helper";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { config } from "../../utils/config";
import Box from '@mui/material/Box';
import { toast } from "react-toastify";
import Modal from '@mui/material/Modal';
import { Modal as AntModal } from "antd"
import { baseUrlDefiner } from "../../utils/config";
import { AnyAaaaRecord } from "dns";
import CloseIcon from '@mui/icons-material/Close';
import { BasicTable } from '../../components/Table';
import { Paginated } from "../../components/Paginated";
import Sellerpagination from "../../components/Paginated/Sellerpagination";
import styles from "./sellerList.module.css"
import '../../components/table.css';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import shiprocketimg from "../../../src/icons/shiprocket.png"
import { Select, Button, Spin, message, Switch, Tabs, Tag, Tooltip, Row, Col, Divider, Avatar } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import CreateProduct from "../catalog/createProduct"
// import createProduct from "../catalog/createProduct";
const { apiEndpoint, baseNodeapiUrl } = config;



const A = () => <span className="badge badge-warning">Pending</span>
const B = () => <span className="badge badge-success">Approved</span>
const C = () => <span className="badge badge-danger">Blocked</span>
const valueToApp: any = {
    "0": <A />,
    "1": <B />,
    "2": <C />
}
var count = 1;

var $ = require('jquery');
const SellerList = () => {
    const decoded: any = tokenDecode();
    const { data } = decoded || {};
    console.log("ghkjhj", data);
    const permissions = data?.permission || {};
    const sellerPermission = permissions?.seller || {};

    const userArray = decoded?.data?.user || decoded?.user || [];
    const userObj = Array.isArray(userArray) ? userArray[0] : (userArray || {});
    const isAdmin = Boolean(
        userObj?.seller_id === "1" ||
        userObj?.seller_id === 1 ||
        userObj?.role_id === 1 ||
        userObj?.parent_id === 0 ||
        userObj?.parent_id === "0" ||
        userObj?.role_name?.toLowerCase()?.includes("admin") ||
        sellerPermission?.edit ||
        sellerPermission?.write
    );

    const [sellerList, setSellerList]: any = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingSellerId, setLoadingSellerId] = useState<any>(null);
    const [blockLoadingSellerId, setBlockLoadingSellerId] = useState<any>(null);
    const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    // const [checkemail, setCheckemail] = useState<any>()

    // const [Userdata, setUserdata] = useState([]);
    const [Userdata, setUserdata] = useState<{ seller: any } | null>(null);

    const [file, setFile] = useState(null);

    const fetchSellerList = async () => {
        setIsLoading(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/sellers/getall`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });

            if (data.status === true || data.status === 200 || data.status) {
                setIsLoading(false);
                setSellerList(data.data || []);

            }
        } catch (error) {
            console.log("error", error);

            setIsLoading(false);
        }
    }
    const handleImport = async () => {
        try {
            if (file) {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const data = e.target.result;
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const json = XLSX.utils.sheet_to_json(worksheet);
                    let dataToSend = json.filter((item: any) => item.name !== null)
                    sendDataToDb(dataToSend);

                };
                reader.readAsArrayBuffer(file);
            }

        } catch (error) {
            console.error('Error handling import:', error);
        }
    };
    const igm = permissions?.igm;
    const showModal = () => {
        setIsModalVisible(true);
    };
    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };


    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');
    const [approveStatus, setApproveStatus] = useState<string>('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(search);
        }, 400);
        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        if (debouncedSearch.trim() === "") {
            if (!approveStatus) {
                fetchSellerList();
            }
        } else {
            filterSellerByName(debouncedSearch);
        }
    }, [debouncedSearch]);

    const searchHandler = (e: any) => {
        const value = e.target.value;
        setSearch(value);
    };

    const filterSellerByName = async (query: string) => {
        if (!query || query.trim() === "") {
            if (approveStatus) {
                filterSellersByStatus(approveStatus);
            } else {
                fetchSellerList();
            }
            return;
        }
        try {
            setIsLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/sellers/filter-seller-name`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                    "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    name: query.trim(),
                },
            });

            console.log("filter-seller-name response:", data);
            const list = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.sellers)
                    ? data.sellers
                    : Array.isArray(data?.seller)
                        ? data.seller
                        : Array.isArray(data?.result)
                            ? data.result
                            : Array.isArray(data)
                                ? data
                                : [];

            setSellerList(list);
            setIsLoading(false);
        } catch (error: any) {
            console.error("Error filtering seller by name:", error);
            setSellerList([]);
            setIsLoading(false);
        }
    };

    const filterSellersByStatus = async (statusValue: string) => {
        setApproveStatus(statusValue);
        if (!statusValue || statusValue === "all" || statusValue === "") {
            if (search.trim()) {
                filterSellerByName(search);
            } else {
                fetchSellerList();
            }
            return;
        }

        try {
            setIsLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/sellers/filter-sellers`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                    "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    approve_status: statusValue,
                },
            });

            console.log("filter-sellers response:", data);
            const list = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.sellers)
                    ? data.sellers
                    : Array.isArray(data?.seller)
                        ? data.seller
                        : Array.isArray(data?.result)
                            ? data.result
                            : Array.isArray(data)
                                ? data
                                : [];

            setSellerList(list);
            setIsLoading(false);
        } catch (error: any) {
            console.error("Error filtering sellers by status:", error);
            setSellerList([]);
            setIsLoading(false);
        }
    };

    async function sendDataToDb(jsonData: any) {
        let apiEndpoint = baseUrlDefiner();
        try {

            let result = await axios({
                url: `${apiEndpoint}/seller_register`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: jsonData,
            })
            if (result.data.status == 200) {
                toast.success(`Seller Registered successfully!`);
                setFile(null);
                let element: any = document.getElementById('inputFile')
                element.value = ''
            } else {
                console.log(result?.data?.error[0]?.message)
                toast.error(`${result?.data?.error[0]?.message} for ${result?.data?.error[0]?.email}`);
                console.log(result?.data?.error[0]?.message)
                toast.error(`${result?.data?.error[0]?.message} for ${result?.data?.error[0]?.email}`);
            }
        } catch (error: any) {
            console.log(error?.response?.data?.error[0]?.message)
            toast.error(`${error?.response?.data?.error[0]?.message} for ${error?.response?.data?.error[0]?.email}`);
        }
    }

    const [sellerdata, setsellerdata] = useState<{ user: any } | null>(null)
    const [shopdata, setshopdata] = useState<{ shop: any } | null>(null)
    const [businessdata, setbusinessdata] = useState<{ bussiness: any } | null>(null);
    const [servicedata, setservicedata] = useState<{ service: any } | null>(null);
    const [rawSellerData, setRawSellerData] = useState<any>(null);
    const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false);

    async function showdata(id: any) {
        setIsDetailLoading(true);
        try {
            let result = await axios({
                url: `${apiEndpoint}/snp/sellers/get/${id}`,
                method: 'GET',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
            });

            const rawData = result?.data?.data || result?.data || {};
            setRawSellerData(rawData);
            const sellerObj = rawData?.seller || {};
            const userObj = rawData?.user || {};
            const kycObj = rawData?.kyc || {};
            const bankObj = rawData?.bank_account || rawData?.bank || {};
            const warehouses = Array.isArray(rawData?.warehouses) ? rawData.warehouses : [];
            const primaryWh = warehouses[0] || {};
            const locationObj = primaryWh?.location || {};
            const services = Array.isArray(rawData?.service) && rawData.service.length > 0
                ? rawData.service
                : (Array.isArray(primaryWh?.service) ? primaryWh.service : []);
            const serviceObj = services[0] || {};

            // 1. Map Seller Data
            const mappedSeller = {
                id: sellerObj.id || userObj.seller_id || id,
                company_name: sellerObj.company_name || primaryWh.warehouse_name || "N/A",
                gst_no: kycObj.gst_no || sellerObj.gst_no || "N/A",
                pan_no: kycObj.pan_no || sellerObj.pan_no || "N/A",
                contact_no: sellerObj.contact_no || userObj.contact_no || "N/A",
                street: locationObj.street || kycObj.personal_address || sellerObj.street || "N/A",
                city: locationObj.city || sellerObj.city || "N/A",
                area_code: locationObj.area_code || sellerObj.area_code || "N/A",
                state: locationObj.state || sellerObj.state || "N/A",
                latitude: locationObj.latitude || sellerObj.latitude || "N/A",
                longitude: locationObj.longitude || sellerObj.longitude || "N/A",
                provider_id: sellerObj.provider_id || userObj.provider_id || primaryWh.provider_id || "N/A",
                bank_account: bankObj.account_no || bankObj.accountnumber || bankObj.account_number || sellerObj.bank_account || "N/A",
                ifsc_code: bankObj.ifsc_code || bankObj.ifsc || sellerObj.ifsc_code || "N/A",
                beneficiary_name: bankObj.account_holder_name || bankObj.name || bankObj.beneficiary_name || "N/A",
                bank_name: bankObj.bank_name || bankObj.bankname || "N/A",
                branch_name: bankObj.branch_name || bankObj.branchname || "N/A",
                status: sellerObj.status !== undefined ? sellerObj.status : userObj.status,
                approve_status: sellerObj.approve_status !== undefined ? sellerObj.approve_status : userObj.approve_status,
                short_description: sellerObj.short_description || "N/A",
                description: sellerObj.description || "N/A",
                city_code: locationObj.city_code || sellerObj.city_code || "N/A",
                locality: locationObj.locality || sellerObj.locality || "N/A",
                radius: locationObj.radius || sellerObj.radius || "N/A"
            };
            setUserdata({ seller: mappedSeller });

            // 2. Map User Data
            const mappedUser = {
                id: userObj.id || "N/A",
                name: userObj.name || "N/A",
                email: userObj.email || userObj.display_email || "N/A",
                contact_no: userObj.contact_no || sellerObj.contact_no || "N/A",
                status: userObj.status !== undefined ? userObj.status : sellerObj.status,
                approve_status: userObj.approve_status !== undefined ? userObj.approve_status : sellerObj.approve_status
            };
            setsellerdata({ user: mappedUser });

            // 3. Map Shop (Warehouse) Data
            const opHours = Array.isArray(primaryWh.operating_hours) ? primaryWh.operating_hours[0] : {};
            const mappedShop = {
                opening_days: opHours?.days || opHours?.opening_days || primaryWh.opening_days || "N/A",
                opening_time: opHours?.start_time || opHours?.opening_time || primaryWh.opening_time || "N/A",
                closing_time: opHours?.end_time || opHours?.closing_time || primaryWh.closing_time || "N/A",
                returnable: primaryWh.returnable !== undefined ? primaryWh.returnable : false,
                replaceable: primaryWh.replaceable !== undefined ? primaryWh.replaceable : false,
                customer_care_contact: primaryWh.warehouse_contact_no || userObj.contact_no || sellerObj.contact_no || "N/A",
                cancelable: primaryWh.cancelable !== undefined ? primaryWh.cancelable : false,
                return_window: primaryWh.return_window || "N/A",
                seller_pickup_return: primaryWh.seller_pickup_return !== undefined ? primaryWh.seller_pickup_return : false,
                time_to_ship: primaryWh.time_to_ship || "N/A",
                cod: primaryWh.cod !== undefined ? primaryWh.cod : false,
                images: sellerObj.logo || kycObj.address_proof_image || "",
                ondc_commission: primaryWh.ondc_commission || sellerObj.ondc_commission || "N/A",
                fssai_licence: primaryWh.fssai_license_no || kycObj.trade_license_no || "N/A",
                status: primaryWh.status !== undefined ? primaryWh.status : true
            };
            setshopdata({ shop: mappedShop });

            // 4. Map Service Data
            const mappedService = {
                service_type: serviceObj.service_type || serviceObj.type || "N/A",
                service_type_code: serviceObj.service_type_code || serviceObj.type_code || "N/A",
                service_range: serviceObj.service_range || serviceObj.range || "N/A",
                service_city: serviceObj.service_city || serviceObj.city || "N/A"
            };
            setservicedata({ service: mappedService });

            // 5. Map Business Data
            const businessType = kycObj.bussiness_type || sellerObj.seller_type;
            setbusinessdata({
                bussiness: businessType ? [businessType] : []
            });

        } catch (error: any) {
            console.log(error?.response?.data?.error?.[0]?.message || error?.message);
            toast.error(error?.response?.data?.message || error?.response?.data?.error?.[0]?.message || "Failed to fetch seller details");
        } finally {
            setIsDetailLoading(false);
        }
    }

    const inputHandler = async (e: any) => {

        try {
            var optionvalue = e.target.value;
            console.log(optionvalue);
            if (optionvalue === "pendingseller") {
                const { data } = await axios({
                    url: `${apiEndpoint}/pendingsellerlist`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    }
                });
                console.log("pending data", data.data);
                setIsLoading(false);
                if (data.status === 200) {
                    setSellerList(data.data);


                }
            }
            else if (optionvalue === "approveseller") {
                const { data } = await axios({
                    url: `${apiEndpoint}/approvesellerlist`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    }
                });
                console.log("pending data", data.data);
                setIsLoading(false);
                if (data.status === 200) {
                    setSellerList(data.data);
                }
            }
            else {
                const { data } = await axios({
                    url: `${apiEndpoint}/snp/sellers/getall`,
                    method: "GET",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                    }
                });
                console.log("allseller data", data.data);
                setIsLoading(false);
                if (data.status === 200 || data.status === true || data.status) {
                    setSellerList(data.data || []);
                }
            }

        } catch (error) {
            console.log("error", error);

            setIsLoading(false);
        }
    };
    const sellerDelete = async (id: any) => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/sellerdelete`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    seller_id: id
                }
            });


            const updateSellerList = sellerList.filter((item: any) => item.id !== id);

            if (data.status === 200) {
                toast.success("Seller Removed Successfully !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            window.location.reload();

        } catch (error) {
            toast.error("403 error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const handleToggleSellerStatus = async (sellerId: any, currentStatus: boolean) => {
        if (!isAdmin) {
            toast.error("Only admin can enable/disable sellers.");
            return;
        }

        const newStatus = !currentStatus;
        setLoadingSellerId(sellerId);

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/sellers/enable-disable/${sellerId}`,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    // "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                    "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    status: newStatus,
                },
            });

            if (data?.status === true || data?.status === 200 || data?.success) {
                toast.success(data?.message || `Seller ${newStatus ? "enabled" : "disabled"} successfully!`);
                setSellerList((prevList: any[]) =>
                    prevList.map((item: any) => {
                        const id = item?.id || item?.seller_id;
                        if (id == sellerId) {
                            return {
                                ...item,
                                status: newStatus,
                                is_active: newStatus ? 1 : 0,
                            };
                        }
                        return item;
                    })
                );
                fetchSellerList()
            } else {
                toast.error(data?.message || "Failed to update seller status.");
            }

        } catch (error: any) {
            console.error("Error updating seller status:", error);
            toast.error(error?.response?.data?.message || error?.message || "Failed to update seller status.");
        } finally {
            setLoadingSellerId(null);
        }
    };

    const handleBlockUnblockSeller = async (sellerId: any, currentApproveStatus: any, kycStatus: any) => {
        if (!isAdmin) {
            toast.error("Only admin can block/unblock sellers.");
            return;
        }

        const isBlocked = String(currentApproveStatus) === "2";

        // When blocking -> always send 2
        // When unblocking -> restore based on kyc_status:
        //   kyc_status truthy (verified) -> was Approved -> restore to 1
        //   kyc_status falsy (null/false) -> was Pending -> restore to 0
        const newApproveStatus = isBlocked ? (kycStatus ? 1 : 0) : 2;

        setBlockLoadingSellerId(sellerId);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/sellers/block/${sellerId}`,
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    approve_status: newApproveStatus,
                },
            });

            if (data?.status === true || data?.status === 200 || data?.success) {
                const label = newApproveStatus === 2 ? "blocked" : newApproveStatus === 1 ? "approved" : "set to pending";
                toast.success(data?.message || `Seller ${label} successfully!`);
                setSellerList((prevList: any[]) =>
                    prevList.map((item: any) => {
                        const id = item?.id || item?.seller_id;
                        if (id == sellerId) {
                            return { ...item, approve_status: newApproveStatus };
                        }
                        return item;
                    })
                );
            } else {
                toast.error(data?.message || "Failed to update seller block status.");
            }
        } catch (error: any) {
            console.error("Error blocking/unblocking seller:", error);
            toast.error(error?.response?.data?.message || error?.message || "Failed to update seller block status.");
        } finally {
            setBlockLoadingSellerId(null);
        }
    };

    const Sstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "10px",
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 2,
    };
    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "ID",
            Footer: "ID",
            accessor: (row: any) => row.id || row.seller_id || "N/A",
            sticky: "left"
        },
        {
            Header: "Company Name",
            Footer: "Company Name",
            accessor: (row: any) => row.company_name || "N/A",
            sticky: "left"
        },
        {
            Header: "Email",
            Footer: "Email",
            accessor: (row: any) => row.email || "N/A",
            sticky: "left"
        },
        {
            Header: "Contact",
            Footer: "Contact",
            accessor: (row: any) => row.contact_no || "N/A",
            sticky: "left"
        },

        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => {
                return <>{valueToApp[row.approve_status] ?? <A />}</>
            },
            sticky: "left"
        },
        {
            Header: "Enable / Disable",
            Footer: "Enable / Disable",
            accessor: (row: any) => {
                const isEnabled = Boolean(
                    row?.status === true ||
                    row?.status === 1 ||
                    row?.status === "1" ||
                    row?.status === "active" ||
                    row?.status === "ENABLE" ||
                    row?.status === "enable" ||
                    row?.is_active === 1 ||
                    row?.is_active === true
                );
                const sellerId = row?.id || row?.seller_id;
                const isRowLoading = loadingSellerId === sellerId;

                return (
                    <div className="d-flex align-items-center justify-content-center" style={{ minWidth: "90px" }}>
                        <Switch
                            checked={isEnabled}
                            loading={isRowLoading}
                            disabled={!isAdmin || isRowLoading}
                            onChange={() => handleToggleSellerStatus(sellerId, isEnabled)}
                            style={{
                                backgroundColor: isEnabled ? "#16A34A" : "#94A3B8"
                            }}
                        />
                    </div>
                );
            },
            sticky: "left"
        },
        {
            Header: "Block / Unblock",
            Footer: "Block / Unblock",
            accessor: (row: any) => {
                const sellerId = row?.id || row?.seller_id;
                const approveStatus = row?.approve_status;
                const kycStatus = row?.kyc_status;
                const isBlocked = String(approveStatus) === "2";
                const isRowLoading = blockLoadingSellerId === sellerId;

                // Label based on all 3 states
                const statusLabel =
                    String(approveStatus) === "2" ? "Blocked" :
                        String(approveStatus) === "1" ? "Approved" :
                            "Pending";
                const statusColor =
                    String(approveStatus) === "2" ? "#DC2626" :
                        String(approveStatus) === "1" ? "#16A34A" :
                            "#F59E0B";

                return (
                    <div className="d-flex flex-column align-items-center justify-content-center gap-1" style={{ minWidth: "110px" }}>
                        <Switch
                            checked={!isBlocked}
                            loading={isRowLoading}
                            disabled={!isAdmin || isRowLoading}
                            onChange={() => handleBlockUnblockSeller(sellerId, approveStatus, kycStatus)}
                            style={{
                                backgroundColor: !isBlocked ? "#16A34A" : "#DC2626",
                            }}
                        />
                        <span style={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: statusColor,
                            letterSpacing: "0.3px"
                        }}>
                            {/* {statusLabel} */}
                        </span>
                    </div>
                );
            },
            sticky: "left"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                const sellerId = row.seller_id || row.id || "";
                const providerId = row.provider_id || "";
                const contactNo = row.contact_no || "";
                return (
                    <>
                        <div className="d-flex align-items-center">
                            <div>
                                <span className="badge badge-secondary" style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        let url = `https://digiportal.xpressbaazaar.com/?navigateToSeller=true&token=${sessionStorage.getItem("token")}&provider_id=${providerId}&contact_no=${contactNo}&seller_id=${sellerId}`
                                        window.open(url, "_blank", "width=800,height=800,noopener,noreferrer");
                                    }}
                                >Log In</span>
                            </div>
                        </div>
                    </>
                )
            },
            sticky: "left"
        },

        {
            Header: "check live",
            Footer: "check live",
            accessor: (row: any) => {
                return (
                    <>
                        <div className="col-md-12 mb-2 d-flex flex-nowrap justify-content-between">
                            <button
                                type="button"
                                onClick={() => {
                                    showModal();
                                    showdata(row?.seller_id || row?.id);
                                }}
                                className="btn btn-success"
                            >
                                View
                            </button>
                        </div>
                    </>
                )
            },
            sticky: "left"
        },

    ];
    count++

    useEffect(() => {
        fetchSellerList();
    }, [])
    function handleShipementModalClose() {
        setshipmentModalOpen(false)
    }

    function getSampleExcelFile() {
        const data = [
            {

                company_name: "Company A",
                name: "John Doe",
                email: "john.doe@example.com",
                image: { shiprocketimg },
                contact_no: "1234567890",
                customer_care_contact: "9876543210",
                pan_name: "Company A Pvt. Ltd.",
                pan_no: "ABCDE1234F",
                gst_no: "GSTIN1234567",
                personal_address: "123, Main Street",
                street: "Main Street",
                locality: "Downtown",
                city: "Cityville",
                state: "State A",
                area_code: "12345",
                seller_city_code: "",
                fssai_licence: "FSSAI1234567890",
                latitude: "12.3456",
                longitude: "78.9101",
                bank_account: "12345678901234",

                ifsc_code: "ABCD0123456",
                beneficiary_name: "John Doe",
                bank_name: "Bank of Example",
                branch_name: "Main Branch",
                radius: "10",
                ondc_commission: "5",
                short_description: "Short description of products",
                description: "Detailed description of products",
                opening_days: "1,2,3,4,5,6,7",
                closing_days: "",
                opening_time: "00:00",
                closing_time: "23:59",
                returnable: false,
                replaceable: false,
                cancelable: false,
                return_window: "P2D",
                seller_pickup_return: false,
                time_to_ship: "P2D",
                address_proof_type: "Aadhar Card",
                gst_registered_address: "Same as personal address",
                cod: false,
                delivery_fee: "0",
                packing_fee: "0",
                holidays: "",
                service_city_code: "",
                ondc_domain: "",
                service_type: "",
                service_range: "",
                service_city: ""
            }
        ];

        const headers = Object.keys(data[0]);

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });

        XLSX.utils.book_append_sheet(wb, ws, 'Orders');

        const fileName = `Sample_Seller_${new Date().getTime()}.xlsx`;

        XLSX.writeFile(wb, fileName);

    }

    const fetchAndDownload = async () => {
        let apiEndpoint = baseUrlDefiner();

        try {
            const result = await axios({
                url: `${apiEndpoint}/sellerexport`,
                method: 'POST',
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                    'Accept': 'application/json'
                },
            });


            const data = result.data?.response;
            const filteredData = data.map((item: any) => ({
                "ID": item.id,
                "Company Name": item.company_name,
                "PAN Name": item.pan_name,
                "PAN Number": item.pan_no,
                "PAN Image": item.pan_image,
                "GST Number": item.gst_no,
                "Contact Number": item.contact_no,
                "Street": item.street,
                "City": item.city,
                "Area Code": item.area_code,
                "State": item.state,
                "Latitude": item.latitude,
                "Longitude": item.longitude,
                "Provider ID": item.provider_id,
                "Personal Address": item.personal_address,
                "Address Proof Type": item.address_proof_type,
                "Address Proof Image": item.address_proof_image,
                "UPI Address": item.upi_address,
                "Bank Account": item.bank_account,
                "IFSC Code": item.ifsc_code,
                "Beneficiary Name": item.beneficiary_name,
                "Bank Name": item.bank_name,
                "Branch Name": item.branch_name,
                "Status": item.status,
                "Approve Status": item.approve_status,
                "Short Description": item.short_description,
                "Description": item.description,
                "Seller Source": item.seller_source,
                "City Code": item.city_code,
                "Token": item.token,
                "Locality": item.locality,
                "Radius": item.radius,
                "GST Image": item.gst_image,
                "GST Registered Address": item.gst_registered_address,
                "Cancelled Cheque Image": item.cancelled_cheque_image,
                "Trade Licence Number": item.trade_licence_number,
                "W Stepcount": item.w_stepcount,
                "Created At": item.created_at,
                "Updated At": item.updated_at,
                "Name": item.name,
                "Email": item.email,
                "Password": item.password,
                "Seller ID": item.seller_id,
                "Parent ID": item.parent_id,
                "Role ID": item.role_id,
                "Display Email": item.display_email,
                "Opening Days": item.opening_days,
                "Closing Days": item.closing_days,
                "Opening Time": item.opening_time,
                "Closing Time": item.closing_time,
                "Returnable": item.returnable,
                "Replaceable": item.replaceable,
                "Customer Care Contact": item.customer_care_contact,
                "Cancelable": item.cancelable,
                "Return Window": item.return_window,
                "Seller Pickup Return": item.seller_pickup_return,
                "Time To Ship": item.time_to_ship,
                "COD": item.cod,
                "Incorporation Date": item.incorporation_date,
                "Images": item.images,
                "Commission": item.commission,
                "ONDC Commission": item.ondc_commission,
                "FSSAI Licence": item.fssai_licence,
                "Seller Commission": item.seller_commission,
                "Delivery Fee": item.delivery_fee,
                "Packing Fee": item.packing_fee,
                "Holidays": item.holidays,
                "FSSAI Licence Image": item.fssai_licence_image,
                "Notification": item.notification,
                "Minimum Amount": item.min_amount,
                "Notify Email": item.notify_email,
                "Service Type": item.service_type,
                "Service Type Code": item.service_type_code,
                "Service Range": item.service_range,
                "Service City": item.service_city,
                "ONDC Domain": item.ondc_domain
            }));

            const worksheet = XLSX.utils.json_to_sheet(filteredData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sellers");
            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });
            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Seller_List.xlsx");
            console.log("Excel file downloaded successfully.");
        } catch (error) {
            if (axios.isAxiosError(error)) {
                console.error("Error Response:", error.response?.data);
            } else {
                console.error("Unknown Error:", error);
            }
        }
    };



    const [modalVisible, setModalVisible] = useState(false);
    const [bapId, setBapId] = useState("");
    const [domain, setDomain] = useState("");
    const [loading, setLoading] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const [selectedSellerId, setSelectedSellerId] = useState<number | null>(null);

    console.log("sellerListsellerListsellerList", sellerList)
    // Dropdown data
    const bapIds = [
        "prd.mystore.in",
        "vishopondc.myvi.in",
        "ondc.nlincs.in",
        "moyto.eazehub.com",
        "api.sahajbazaar.in",
        "sabhyasha.eazehub.com",
        "buysimplynow.eazehub.com",
        "mappls.com",
        "bharatham-backend.bharath.am",
    ];

    const domains = [
        { name: "Grocery", value: "ONDC:RET10" },
        { name: "Fashion", value: "ONDC:RET12" },
        { name: "BPC", value: "ONDC:RET13" },
        { name: "Electronics", value: "ONDC:RET14" },
        { name: "Appliances", value: "ONDC:RET15" },
        { name: "Home & Kitchen", value: "ONDC:RET16" },
        { name: "Health & Wellness", value: "ONDC:RET18" },
    ];

    const handleSearch = async () => {
        if (!bapId || !domain) {
            message.warning("Please select both BAP ID and Domain.");
            return;
        }

        setLoading(true);
        setResponseData(null);

        try {
            const now = new Date();
            const startDate = new Date(now.setHours(0, 1, 0, 0)).toISOString();
            const endDate = new Date(now.setHours(23, 59, 59, 999)).toISOString();

            const body = {
                start_time: startDate,
                end_time: endDate,
                domain,
                seller_id: selectedSellerId, // send selected seller id
                bap_id: bapId,
            };

            console.log("📤 Request:", body);

            const response = await fetch(
                `${baseNodeapiUrl}/shiprocket/incremental_search`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(body),
                }
            );

            const data = await response.json();
            setResponseData(data);
            message.success("Data fetched successfully!");
        } catch (error) {
            console.error("❌ Error:", error);
            message.error("Failed to fetch incremental data!");
        } finally {
            setLoading(false);
        }
    };

    const handleIncrementalCancel = () => {
        setModalVisible(false);
        setResponseData(null);
        setBapId("");
        setDomain("");
    };



    return (
        <>

            <ThemeMaker>





                <>
                    <Modal
                        open={shipmentModalOpen}
                        // onClose={handleShipementModalClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={Sstyle} className="col-md-4 w-100 w-md-25">

                            <div className="modal-content ">
                                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                                    <p className="modal-title genericlabel d-flex justify-content-between w-100" style={{ letterSpacing: "1px" }}> <span>   </span>  <a onClick={() => { getSampleExcelFile() }} style={{ cursor: "pointer" }} >Download Sample Excel</a> </p>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="importingSection">
                                        <input type="file" id="inputFile" onChange={(e) => {
                                            const file: any = e.target.files && e.target.files.length > 0 ? e.target.files[0] : null;
                                            setFile(file);
                                        }}
                                            style={{ marginTop: "30px" }}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-primary" onClick={handleImport} > Submit </button>
                                </div>
                            </div>
                        </Box>
                    </Modal>

                </>
                <div className="row w-100 m-0 mt-1">
                    <div className="col-md-12 ">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3 px-4 d-flex flex-wrap justify-content-between align-items-center bg-white" style={{ gap: "12px", borderBottom: "1px solid #F1F5F9", position: "sticky", top: "10px", zIndex: 30 }}>
                                <h5 className="m-0 font-weight-bold" style={{ color: "#0F172A", fontSize: "20px" }}>
                                    Seller List
                                </h5>

                                <div className="d-flex align-items-center flex-wrap" style={{ gap: "12px" }}>
                                    {/* Search Seller Name Filter Fieldset */}
                                    <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                                        <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                                            Search Seller Name
                                        </legend>
                                        <div className="d-flex align-items-center" style={{ marginTop: "-2px" }}>
                                            <i className="fas fa-search" style={{ color: "#F97316", marginRight: "8px", fontSize: "12px" }}></i>
                                            <input
                                                type="text"
                                                value={search}
                                                onChange={searchHandler}
                                                placeholder="Search Seller Name..."
                                                style={{ border: "none", outline: "none", width: "220px", fontSize: "13px", color: "#1E293B", backgroundColor: "transparent" }}
                                            />
                                            {search && (
                                                <i
                                                    className="fas fa-times"
                                                    style={{ color: "#94A3B8", cursor: "pointer", fontSize: "12px", marginLeft: "4px" }}
                                                    onClick={() => {
                                                        setSearch("");
                                                        if (approveStatus) {
                                                            filterSellersByStatus(approveStatus);
                                                        } else {
                                                            fetchSellerList();
                                                        }
                                                    }}
                                                ></i>
                                            )}
                                        </div>
                                    </fieldset>

                                    {/* Approval Status Filter Fieldset */}
                                    <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                                        <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                                            Approval Status
                                        </legend>
                                        <div className="d-flex align-items-center" style={{ marginTop: "-2px" }}>
                                            <select
                                                value={approveStatus}
                                                onChange={(e) => filterSellersByStatus(e.target.value)}
                                                style={{
                                                    border: "none",
                                                    outline: "none",
                                                    backgroundColor: "transparent",
                                                    fontSize: "13px",
                                                    color: "#1E293B",
                                                    fontWeight: 500,
                                                    cursor: "pointer",
                                                    paddingRight: "8px"
                                                }}
                                            >
                                                <option value="">All Status</option>
                                                <option value="0">Pending / New Request</option>
                                                <option value="1">Approved</option>
                                            </select>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div className="">

                                {/* <div className="flex">
                                    <div>
                                        <h6 className="m-0 font-weight-bold  text-left">
                                            Search By
                                        </h6>
                                    </div>
                                    <div>
                                        <input type="text" value={search} onChange={searchHandler}
                                            className="border border-gray-300 rounded px-2 py-1"
                                            placeholder="search seller..." />
                                    </div>
                                </div> */}
                                {/* <div className={styles.sellerListOptions}> <b>Filter By: </b><select name="status" id="" onChange={(e: any) => inputHandler(e)}>
                                    <option value="allseller" selected >All</option>
                                    <option value="pendingseller">Pending Seller</option>
                                    <option value="approveseller">Approved Seller</option>
                                </select>
                                </div> */}
                                <>
                                    {/* Main trigger button */}
                                    {/* <div className="">
                                        <Button
                                            type="primary"
                                            icon={<SearchOutlined />}
                                            className="btn btn-primary"
                                            onClick={() => setModalVisible(true)}
                                            style={{
                                                backgroundColor: "#1e88e5",
                                                borderRadius: "6px",
                                                fontWeight: 500,
                                                boxShadow: "0 2px 6px rgba(30,136,229,0.3)",
                                                marginTop: "5px",
                                            }}
                                        >
                                            Incremental Search
                                        </Button>
                                    </div> */}

                                    {/* Your existing custom modal */}
                                    <AntModal
                                        className="custom-left-modal "
                                        open={modalVisible}
                                        onOk={handleSearch}
                                        onCancel={handleIncrementalCancel}
                                        width={400}
                                        okText="Run Search"
                                        cancelText="Close"
                                    >
                                        <div style={{ padding: "10px 0" }}>
                                            <h5 style={{ color: "#1e88e5", fontWeight: 600, marginBottom: 10 }}>
                                                Incremental Search
                                            </h5>

                                            {/* BAP ID Dropdown */}
                                            <div style={{ marginBottom: 16 }}>
                                                <label style={{ fontWeight: 500 }}>Select BAP ID:</label>
                                                <Select
                                                    placeholder="Choose BAP ID"
                                                    style={{ width: "100%", marginTop: 6 }}
                                                    value={bapId || undefined}
                                                    onChange={(value) => setBapId(value)}
                                                    showSearch
                                                    optionFilterProp="label"
                                                    options={bapIds.map((id) => ({ label: id, value: id }))}
                                                ></Select>
                                            </div>

                                            {/* Domain Dropdown */}
                                            <div style={{ marginBottom: 16 }}>
                                                <label style={{ fontWeight: 500 }}>Select Domain:</label>
                                                <Select
                                                    placeholder="Choose Domain"
                                                    style={{ width: "100%", marginTop: 6 }}
                                                    value={domain || undefined}
                                                    onChange={(value) => setDomain(value)}
                                                    options={domains.map((d) => ({
                                                        label: `${d.name} (${d.value})`,
                                                        value: d.value,
                                                    }))}
                                                />
                                            </div>
                                            {/* Seller Dropdown */}
                                            <div style={{ marginBottom: 16 }}>
                                                <label style={{ fontWeight: 500 }}>Select Seller:</label>
                                                <Select
                                                    placeholder="Choose Seller"
                                                    style={{ width: "100%", marginTop: 6 }}
                                                    value={selectedSellerId || undefined} // state for selected seller
                                                    onChange={(value) => setSelectedSellerId(value)} // value will be seller_id
                                                    showSearch
                                                    optionFilterProp="label"
                                                    options={sellerList.map((seller: any) => ({
                                                        label: seller.company_name || seller.contact_no || seller.provider_id || seller.id,
                                                        value: seller.seller_id || seller.id,
                                                    }))}
                                                />
                                            </div>


                                            {/* Loading spinner */}
                                            {loading && (
                                                <div style={{ textAlign: "center", padding: "12px" }}>
                                                    <Spin size="large" />
                                                </div>
                                            )}


                                        </div>
                                    </AntModal>
                                </>
                            </div>



                            {/* <div className="d-flex justify-content-end m-2">
                                <span className="text-center mx-2" style={{ background: "lightgrey", borderRadius: "12px", fontSize: "14px", width: "150px", color: "black", fontWeight: "600", height: "27px", cursor: "pointer", paddingTop: "3px" }}
                                    onClick={fetchAndDownload}
                                >Export Seller</span>



                                <span className="text-center" style={{ background: "lightgrey", borderRadius: "12px", fontSize: "14px", width: "150px", color: "black", fontWeight: "600", height: "27px", cursor: "pointer", paddingTop: "3px" }}
                                    onClick={() => {
                                        setshipmentModalOpen(true)
                                    }}
                                >Import Sellers</span>

                            </div> */}

                            <div className={`card-body p-0 ${styles.cardbody}`}>
                                <div className="table table-responsive ">
                                    <div className={styles.sellerListing_desktop} >
                                        <Paginated data={sellerList} columns={COLUMNS as any} />
                                    </div>
                                    <div className={styles.sellerListing_mobile}>
                                        <Sellerpagination itemsPerPage={20} items={sellerList} sellerDelete={sellerDelete} paginationFor="seller"></Sellerpagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Modern Beautified Seller Details Full Modal */}
                <AntModal
                    open={isModalVisible}
                    onCancel={handleCancel}
                    width={1040}
                    footer={null}
                    centered
                    closable={true}
                    maskClosable={true}
                    destroyOnClose={true}
                    bodyStyle={{ padding: 0, overflow: "hidden", borderRadius: "16px" }}
                    style={{ borderRadius: "16px", overflow: "hidden" }}
                >
                    <Spin spinning={isDetailLoading}>
                        {/* Top Header Card */}
                        <div style={{
                            background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
                            color: "#FFFFFF",
                            padding: "24px 28px",
                            position: "relative",
                            borderBottom: "2px solid #F97316"
                        }}>
                            <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: "16px" }}>
                                <div className="d-flex align-items-center" style={{ gap: "16px" }}>
                                    <div style={{
                                        width: "64px",
                                        height: "64px",
                                        borderRadius: "12px",
                                        background: "linear-gradient(135deg, #F97316, #EA580C)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "24px",
                                        fontWeight: 700,
                                        color: "#FFFFFF",
                                        boxShadow: "0 4px 12px rgba(249, 115, 22, 0.35)",
                                        overflow: "hidden",
                                        flexShrink: 0
                                    }}>
                                        {Userdata?.seller?.logo || shopdata?.shop?.images ? (
                                            <img
                                                src={Userdata?.seller?.logo || shopdata?.shop?.images}
                                                alt="logo"
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                        ) : (
                                            (Userdata?.seller?.company_name?.[0])?.toUpperCase() || "S"
                                        )}
                                    </div>
                                    <div>
                                        <div className="d-flex align-items-center" style={{ gap: "10px", flexWrap: "wrap" }}>
                                            <h3 style={{ margin: 0, color: "#FFFFFF", fontWeight: 700, fontSize: "20px", letterSpacing: "0.3px" }}>
                                                {Userdata?.seller?.company_name || "Seller Details"}
                                            </h3>
                                            <Tag color="orange" style={{ fontWeight: 600, borderRadius: "4px", margin: 0 }}>
                                                ID: #{Userdata?.seller?.id || "N/A"}
                                            </Tag>
                                            {businessdata?.bussiness?.[0] && (
                                                <Tag color="blue" style={{ fontWeight: 600, borderRadius: "4px", margin: 0 }}>
                                                    {businessdata.bussiness[0]}
                                                </Tag>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center mt-2" style={{ gap: "14px", fontSize: "12px", color: "#94A3B8", flexWrap: "wrap" }}>
                                            <span>
                                                <i className="fas fa-fingerprint me-1" style={{ color: "#F97316" }}></i>
                                                Provider: <b style={{ color: "#E2E8F0" }}>{Userdata?.seller?.provider_id || "N/A"}</b>
                                            </span>
                                            <span>•</span>
                                            <span>
                                                <i className="fas fa-phone me-1" style={{ color: "#F97316" }}></i>
                                                <b style={{ color: "#E2E8F0" }}>{Userdata?.seller?.contact_no || sellerdata?.user?.contact_no || "N/A"}</b>
                                            </span>
                                            {sellerdata?.user?.email && (
                                                <>
                                                    <span>•</span>
                                                    <span>
                                                        <i className="fas fa-envelope me-1" style={{ color: "#F97316" }}></i>
                                                        <b style={{ color: "#E2E8F0" }}>{sellerdata.user.email}</b>
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center" style={{ gap: "10px", flexWrap: "wrap" }}>
                                    <Tag color={Userdata?.seller?.status ? "success" : "error"} style={{ fontSize: "12px", padding: "4px 12px", fontWeight: 600, borderRadius: "20px", margin: 0 }}>
                                        {Userdata?.seller?.status ? "● Active" : "● Inactive"}
                                    </Tag>
                                    <Tag color={Userdata?.seller?.approve_status === 1 ? "processing" : "warning"} style={{ fontSize: "12px", padding: "4px 12px", fontWeight: 600, borderRadius: "20px", margin: 0 }}>
                                        {Userdata?.seller?.approve_status === 1 ? "✓ Approved" : "⏳ Pending Approval"}
                                    </Tag>
                                    <Button
                                        type="primary"
                                        size="small"
                                        onClick={() => {
                                            let url = `https://digiportal.xpressbaazaar.com/?navigateToSeller=true&token=${sessionStorage.getItem("token")}&provider_id=${Userdata?.seller?.provider_id}&contact_no=${Userdata?.seller?.contact_no}&seller_id=${Userdata?.seller?.id}`;
                                            window.open(url, "_blank", "width=800,height=800,noopener,noreferrer");
                                        }}
                                        style={{
                                            background: "linear-gradient(90deg, #F97316, #FC8809)",
                                            borderColor: "#F97316",
                                            fontWeight: 600,
                                            borderRadius: "6px",
                                            height: "32px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "6px"
                                        }}
                                    >
                                        <i className="fas fa-external-link-alt"></i> Login Portal
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Modal Body with Styled Tabs */}
                        <div style={{ padding: "20px 24px", minHeight: "440px", maxHeight: "68vh", overflowY: "auto", background: "#F8FAFC" }}>
                            <Tabs
                                defaultActiveKey="1"
                                type="card"
                                items={[
                                    {
                                        key: "1",
                                        label: <span style={{ fontWeight: 600 }}><i className="fas fa-building me-2" style={{ color: "#F97316" }}></i>Business & KYC</span>,
                                        children: (
                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "8px" }}>
                                                {/* Card 1: Company Profile */}
                                                <div style={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "10px", padding: "18px" }}>
                                                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0F172A", marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <i className="fas fa-id-card" style={{ color: "#F97316" }}></i> Company Information
                                                    </div>
                                                    <Row gutter={[12, 12]}>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Company Name</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.company_name || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>GST Number</span>
                                                                    <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.gst_no || "N/A"}</div>
                                                                </div>
                                                                {Userdata?.seller?.gst_no && Userdata.seller.gst_no !== "N/A" && (
                                                                    <Tooltip title="Copy GSTIN">
                                                                        <Button type="text" size="small" icon={<i className="far fa-copy" style={{ color: "#94A3B8" }}></i>} onClick={() => { navigator.clipboard.writeText(Userdata.seller.gst_no); message.success("GST Number copied!"); }} />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>PAN Number</span>
                                                                    <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.pan_no || "N/A"}</div>
                                                                </div>
                                                                {Userdata?.seller?.pan_no && Userdata.seller.pan_no !== "N/A" && (
                                                                    <Tooltip title="Copy PAN">
                                                                        <Button type="text" size="small" icon={<i className="far fa-copy" style={{ color: "#94A3B8" }}></i>} onClick={() => { navigator.clipboard.writeText(Userdata.seller.pan_no); message.success("PAN Number copied!"); }} />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Contact Number</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.contact_no || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Business Type</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{businessdata?.bussiness?.join(", ") || rawSellerData?.kyc?.bussiness_type || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Verification Type</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px", textTransform: "uppercase" }}>{rawSellerData?.seller?.verification_type || "GST"}</div>
                                                            </div>
                                                        </Col>
                                                        {Userdata?.seller?.short_description && (
                                                            <Col xs={24} md={12}>
                                                                <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Short Description</span>
                                                                    <div style={{ fontSize: "13px", color: "#334155", marginTop: "3px" }}>{Userdata.seller.short_description}</div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                        {Userdata?.seller?.description && (
                                                            <Col xs={24} md={12}>
                                                                <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Description</span>
                                                                    <div style={{ fontSize: "13px", color: "#334155", marginTop: "3px" }}>{Userdata.seller.description}</div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </div>

                                                {/* Card 2: KYC & Address Verification */}
                                                <div style={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "10px", padding: "18px" }}>
                                                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0F172A", marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <i className="fas fa-shield-alt" style={{ color: "#16A34A" }}></i> KYC & Address Verification
                                                    </div>
                                                    <Row gutter={[12, 12]}>
                                                        <Col xs={24} md={12}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Personal / Aadhaar Address</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 500, color: "#0F172A", marginTop: "3px" }}>
                                                                    {rawSellerData?.kyc?.personal_address || Userdata?.seller?.street || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} md={12}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>GST Registered Address</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 500, color: "#0F172A", marginTop: "3px" }}>
                                                                    {rawSellerData?.kyc?.gst_registered_address || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={6}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Address Proof Type</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px", textTransform: "capitalize" }}>
                                                                    {rawSellerData?.kyc?.address_proof_type || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={6}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>GST KYC Status</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color={rawSellerData?.kyc?.gst_kyc ? "success" : "default"}>{rawSellerData?.kyc?.gst_kyc ? "✓ Verified" : "Not Verified"}</Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={6}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Penny Drop KYC</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color={rawSellerData?.kyc?.pennydrop_kyc ? "success" : "default"}>{rawSellerData?.kyc?.pennydrop_kyc ? "✓ Verified" : "Not Verified"}</Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={6}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>PAN-Aadhaar KYC</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color={rawSellerData?.kyc?.panaadhar_kyc ? "success" : "default"}>{rawSellerData?.kyc?.panaadhar_kyc ? "✓ Verified" : "Not Verified"}</Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {rawSellerData?.kyc?.address_proof_image && (
                                                            <Col xs={24} sm={12} md={6}>
                                                                <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Document Proof</span>
                                                                    <div style={{ marginTop: "6px" }}>
                                                                        <a href={rawSellerData.kyc.address_proof_image} target="_blank" rel="noreferrer" style={{ fontSize: "12px", color: "#F97316", fontWeight: 600 }}>
                                                                            <i className="fas fa-external-link-alt me-1"></i> View Document
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    },
                                    {
                                        key: "2",
                                        label: <span style={{ fontWeight: 600 }}><i className="fas fa-university me-2" style={{ color: "#2563EB" }}></i>Bank Account</span>,
                                        children: (
                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "8px" }}>
                                                <div style={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "10px", padding: "18px" }}>
                                                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0F172A", marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <i className="fas fa-landmark" style={{ color: "#2563EB" }}></i> Bank Account Information
                                                    </div>
                                                    <Row gutter={[12, 12]}>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Account Holder / Beneficiary</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                    {Userdata?.seller?.beneficiary_name || rawSellerData?.bank_account?.account_holder_name || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Account Number</span>
                                                                    <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                        {Userdata?.seller?.bank_account || rawSellerData?.bank_account?.account_no || "N/A"}
                                                                    </div>
                                                                </div>
                                                                {(Userdata?.seller?.bank_account || rawSellerData?.bank_account?.account_no) && (
                                                                    <Tooltip title="Copy Account Number">
                                                                        <Button
                                                                            type="text"
                                                                            size="small"
                                                                            icon={<i className="far fa-copy" style={{ color: "#94A3B8" }}></i>}
                                                                            onClick={() => {
                                                                                navigator.clipboard.writeText(Userdata?.seller?.bank_account || rawSellerData?.bank_account?.account_no);
                                                                                message.success("Account Number copied!");
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div>
                                                                    <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>IFSC Code</span>
                                                                    <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                        {Userdata?.seller?.ifsc_code || rawSellerData?.bank_account?.ifsc_code || "N/A"}
                                                                    </div>
                                                                </div>
                                                                {(Userdata?.seller?.ifsc_code || rawSellerData?.bank_account?.ifsc_code) && (
                                                                    <Tooltip title="Copy IFSC Code">
                                                                        <Button
                                                                            type="text"
                                                                            size="small"
                                                                            icon={<i className="far fa-copy" style={{ color: "#94A3B8" }}></i>}
                                                                            onClick={() => {
                                                                                navigator.clipboard.writeText(Userdata?.seller?.ifsc_code || rawSellerData?.bank_account?.ifsc_code);
                                                                                message.success("IFSC Code copied!");
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Bank Name</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                    {Userdata?.seller?.bank_name || rawSellerData?.bank_account?.bank_name || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Branch Name</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                    {Userdata?.seller?.branch_name || rawSellerData?.bank_account?.branch_name || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={4}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Account Type</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color="blue" style={{ fontWeight: 600, margin: 0 }}>
                                                                        {rawSellerData?.bank_account?.account_type ? rawSellerData.bank_account.account_type.toUpperCase() : "SAVINGS"}
                                                                    </Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={4}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Verification Status</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color="success" style={{ fontWeight: 600, margin: 0 }}>✓ Verified</Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                {/* Card 2: Settlement & Verification Status */}
                                                <div style={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "10px", padding: "18px" }}>
                                                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0F172A", marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <i className="fas fa-shield-alt" style={{ color: "#16A34A" }}></i> Verification & Settlement Details
                                                    </div>
                                                    <Row gutter={[12, 12]}>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Penny Drop Verification</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color={rawSellerData?.kyc?.pennydrop_kyc ? "success" : "default"}>
                                                                        {rawSellerData?.kyc?.pennydrop_kyc ? "✓ Verified" : "Not Verified"}
                                                                    </Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Settlement Status</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color="success">✓ Active for Payouts</Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Linked Provider ID</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                    {Userdata?.seller?.provider_id || rawSellerData?.bank_account?.provider_id || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    },
                                    {
                                        key: "3",
                                        label: <span style={{ fontWeight: 600 }}><i className="fas fa-warehouse me-2" style={{ color: "#7C3AED" }}></i>Warehouse & Location</span>,
                                        children: (
                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "8px" }}>
                                                <div style={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "10px", padding: "18px" }}>
                                                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0F172A", marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <i className="fas fa-map-marker-alt" style={{ color: "#DC2626" }}></i> Location Details
                                                    </div>
                                                    <Row gutter={[12, 12]}>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Street Address</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.street || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Locality</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.locality || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>City</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.city || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>State</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.state || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Area Code (Pincode)</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.area_code || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>City Code</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.city_code || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Latitude</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.latitude || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Longitude</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.longitude || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Delivery Radius</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{Userdata?.seller?.radius ? `${Userdata.seller.radius} meters` : "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    },
                                    {
                                        key: "4",
                                        label: <span style={{ fontWeight: 600 }}><i className="fas fa-user-circle me-2" style={{ color: "#0284C7" }}></i>User & Role</span>,
                                        children: (
                                            <div style={{ marginTop: "8px" }}>
                                                <div style={{ background: "#FFFFFF", border: "1px solid #E2E8F0", borderRadius: "10px", padding: "18px" }}>
                                                    <div style={{ fontSize: "14px", fontWeight: 700, color: "#0F172A", marginBottom: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <i className="fas fa-user-shield" style={{ color: "#0284C7" }}></i> Primary User Account
                                                    </div>
                                                    <Row gutter={[12, 12]}>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Full Name</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{sellerdata?.user?.name || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Email Address</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{sellerdata?.user?.email || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Contact Number</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>{sellerdata?.user?.contact_no || "N/A"}</div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Role ID / Parent ID</span>
                                                                <div style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", marginTop: "3px" }}>
                                                                    Role: #{rawSellerData?.user?.role_id || "N/A"} | Parent: #{rawSellerData?.user?.parent_id || "N/A"}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Account Status</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color={sellerdata?.user?.status ? "success" : "error"}>{sellerdata?.user?.status ? "Active" : "Inactive"}</Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={24} sm={12} md={8}>
                                                            <div style={{ background: "#F8FAFC", padding: "10px 14px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                                                                <span style={{ fontSize: "11px", color: "#64748B", fontWeight: 600, textTransform: "uppercase" }}>Approval Status</span>
                                                                <div style={{ marginTop: "3px" }}>
                                                                    <Tag color={(sellerdata?.user?.approve_status === 1 || (sellerdata as any)?.seller?.approve_status === 1) ? "processing" : "warning"}>
                                                                        {(sellerdata?.user?.approve_status === 1 || (sellerdata as any)?.seller?.approve_status === 1) ? "Approved" : "Pending"}
                                                                    </Tag>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    }
                                ]}
                            />
                        </div>

                        {/* Modal Footer */}
                        <div style={{
                            padding: "12px 24px",
                            background: "#FFFFFF",
                            borderTop: "1px solid #E2E8F0",
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center"
                        }}>
                            <Button onClick={handleCancel} style={{ borderRadius: "6px", fontWeight: 600, minWidth: "90px" }}>
                                Close
                            </Button>
                        </div>
                    </Spin>
                    {/* <createProduct data={sellerList} /> */}
                </AntModal>
            </ThemeMaker>
            {/* <div style={{ display: "none" }}>
                <CreateProduct checkemail={checkemail} />
            </div> */}

        </>
    )
}

export default SellerList;